import React, { Component } from 'react'

export default class CargandoView extends Component {
  static propTypes = {}

  render() {
    return <div className="common-cargando-view">Cargando...</div>
  }
}
